import React from 'react';
import { array, func, bool, object, number } from 'prop-types';
import { isEmpty } from 'lodash';
import { logger } from '@fiverr-private/obs';
import { reportClearFilterEvent, TYPES } from '../../../utils/reports/filter/clearFilter';
import { shouldDisplayBusinessFilter } from '../../../utils/business';
import { useReviewsContext } from '../context';
import FilterReviews from '../FilterReviews';
import Business from './Business';
import Breakdown from './Breakdown';
import FilterDetails from './FilterDetails';
import IndustrySelection from './IndustrySelection';
import WorkSample from './WorkSample';
import SearchBox from './SearchBox';

const CLEAR_FILTER = 'clear filter';

const Filters = (props) => {
    const {
        fetchReviews,
        headerProps,
        breakdown,
        displayBreakdown,
        clearFilters,
        workSampleFilterCount,
        displayIndustry,
        currentUserIndustries,
        commonIndustries,
        businessFilterCount,
        showSortFilters,
    } = props;

    const { onFilterChange } = headerProps;

    const { enableSearchFilter } = useReviewsContext();

    const clearFilter = () => {
        clearFilters()
            .then((eventData) => {
                reportClearFilterEvent(TYPES.ratingsFilterClear, { ...eventData, text: CLEAR_FILTER });
            })
            .catch((error) => {
                logger.error(error, {
                    func: 'clearFilters',
                    component: 'Filters',
                });
            });
    };

    const displayWorkSample = workSampleFilterCount > 0;
    const displayBusiness = businessFilterCount > 0 && shouldDisplayBusinessFilter();
    const shouldDisplayIndustry = displayIndustry && (!isEmpty(currentUserIndustries) || !isEmpty(commonIndustries));
    const multipleFilters = (shouldDisplayIndustry || displayBusiness) + displayWorkSample > 1;
    const showBreakdownFilters = displayBreakdown && breakdown;
    const hasAnyFilters = enableSearchFilter || displayWorkSample || displayBusiness || shouldDisplayIndustry;

    if (!showBreakdownFilters && !enableSearchFilter) {
        return null;
    }

    return (
        <span>
            {showBreakdownFilters ? (
                <>
                    <Breakdown {...headerProps} />
                    {hasAnyFilters && (
                        <div className="filters-wrapper">
                            <div className="filters-list">
                                {enableSearchFilter && <SearchBox />}
                                {showSortFilters && (
                                    <FilterReviews
                                        onFilterChange={onFilterChange}
                                        fetchReviews={fetchReviews}
                                        className="filter-reviews m-b-4"
                                    />
                                )}
                                <WorkSample multipleFilters={multipleFilters} />
                                {displayBusiness && <Business />}
                                {shouldDisplayIndustry && <IndustrySelection multipleFilters={multipleFilters} />}
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <>
                    {enableSearchFilter && <SearchBox />}
                    {showSortFilters && (
                        <FilterReviews onFilterChange={onFilterChange} fetchReviews={fetchReviews} className="m-b-8" />
                    )}
                </>
            )}
            <FilterDetails onClear={clearFilter} />
        </span>
    );
};

Filters.propTypes = {
    selectedStars: array,
    clearFilters: func,
    breakdown: array,
    displayBreakdown: bool,
    headerProps: object,
    workSampleChecked: bool,
    includeCurrentUserIndustry: bool,
    workSampleFilterCount: number,
    currentUserIndustries: object,
    commonIndustries: object,
    displayIndustry: bool,
    businessFilterCount: number,
    fetchReviews: func,
    onFilterChange: func,
    showSortFilters: bool,
};

Filters.defaultProps = {
    headerProps: {},
    breakdown: null,
    workSampleChecked: false,
    includeCurrentUserIndustry: false,
    selectedStars: [],
    workSampleFilterCount: 0,
    commonIndustryCount: 0,
    displayIndustry: false,
    businessFilterCount: 0,
    showSortFilters: true,
};

export default Filters;
